// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g1LtC","content":"styles_content__1X_Ea"};